module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/document-fae6c5c20f800f5419847dc9999e445f.svg";